import { createFileRoute } from '@tanstack/react-router';
import { JourneysNewsletterOverviewHandoff } from '@/pages/workspaces/broadcasts/newsletter/overview/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletter/$newsletterId/overview',
)({
  component: JourneysNewsletterOverviewHandoff,
});
